"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorRecorder_1 = __importDefault(require("./ErrorRecorder"));
var Router_1 = __importDefault(require("./Router"));
var Loader_1 = __importDefault(require("./Loader"));
var Saver_1 = __importDefault(require("./Saver"));
var CursorValidator_1 = __importDefault(require("./CursorValidator"));
var Configurations_1 = __importDefault(require("./Configuration/Configurations"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var DEFAULT_CONFIGURATION_NAME = "standard";
exports.default = (function (di, usingFeature, block, model, maybeConfigurationName) {
    var errorRecorder = new ErrorRecorder_1.default(block.projectId, block._id);
    var router = new Router_1.default(errorRecorder, usingFeature);
    var loader = di.make(Loader_1.default);
    var saver = di.has("model") ? di.make(Saver_1.default) : di.make(Saver_1.default, { model: model });
    var showSpinner = di.has("showSpinner") ? di.get("showSpinner") : true;
    setTimeout(function () {
        document.execCommand("enableObjectResizing", false, "false");
        document.execCommand("enableInlineTableEditing", false, "false");
    });
    var cursorValidator = di.make(CursorValidator_1.default);
    if (!di.has("cursorValidator")) {
        di.value("cursorValidator", cursorValidator);
    }
    var configurationName = maybeConfigurationName || DEFAULT_CONFIGURATION_NAME;
    var configurationObject = Configurations_1.default[configurationName];
    if (usingFeature(FeatureFlag_1.default.OptOutTCDC)) {
        configurationObject.toolbarConfiguration = configurationObject.toolbarConfiguration.filter(function (button) {
            return button.type != "style";
        });
    }
    if (block.$editors == null) {
        block.$editors = [];
    }
    block.$editors.push(function () {
        loader.loadContent(model.tokens || []);
    });
    block.$triggerLoad = function () {
        var e_1, _a;
        try {
            for (var _b = __values(block.$editors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var editorLoad = _c.value;
                editorLoad();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return {
        errorRecorder: errorRecorder,
        showSpinner: showSpinner,
        router: router,
        loader: loader,
        saver: saver,
        cursorValidator: cursorValidator,
        configurationObject: configurationObject,
    };
});
